<template>
  <div class="article-detail">
  <div class="article-detail__container">
    <AppBreadCrumbs/>
    <div class="article-item--detail">
      <div class="article-item__header">
        <p class="text-TTDrugs-bold-24 left">Статья #1</p>
      </div>

      <div class="article-item__content">
        <div class="article-item__title">
          <p class="text-TTDrugs-bold-20 color-green left">Эффективность комбинированной терапии комплексом противомикробных пептидов и цитокинов и природным антикоагулянтом прямого действия у пациенток с эндометриальным бесплодием: первые результаты сравнительного исследования</p>
        </div>
        <div class="article-item__image--detail">
          <img src="../assets/img/section8-1-index.jpg" alt="Article image"  />
        </div>

        <p class="text-circe-light-18 left">Говоря о многообразии факторов женской инфертильности, стоит отметить значение аспекта несостоятельности ткани слизистой полости матки, что в первую очередь ассоциировано с персистирующим воспалительным процессом [1–3]. Реализация патологического процесса в эндометрии подразумевает формирование основы его структурно-функциональной недостаточности, что проявляется нарушениями субэндометриального кровотока, неполноценной регенерацией ткани, а также неадекватной рецепторной чувствительностью. В настоящее время активно изучаются особенности влияния различных факторов на результативность процесса имплантации [4]. Согласно распространенной на сегодняшний день точке зрения имплантация может быть рассмотрена как процесс, во многом сходный с воспалительным, поскольку в нем принимают активное участие сосудистые и иммунные механизмы. Ряд исследований это подтверждает, демонстрируя, что успех имплантации в том числе определяется балансом между действием провоспалительных и противовоспалительных цитокинов. Кроме того, заслуживает внимания тезис, что одним из ведущих механизмов неудач имплантации и потерь беременности становятся проблемы со стороны прокоагулянтного и антикоагулянтного звеньев гемостаза. Из-за деактивации фибринолиза по причине неадекватной реакции на влияние провоспалительных факторов на фоне микроциркуляторных расстройств, ишемизации эндометрия и прогрессирующего фиброзирования стромы и склерозирования сосудов структурно-функциональные нарушения ткани постепенно усиливаются [2]. По данным зарубежных авторов, при морфологическом исследовании сосудистые изменения в 85,7% случаев ассоциированы с хроническим эндометритом [5].</p>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
  import AppBreadCrumbs from '@/components/BreadCrumbs.vue'

  export default {
    name: "AppArticleDetail",
    components: { AppBreadCrumbs },
    props: ['id'],
    data() {
      return {
        article: {
          title: '',
          content: ''
        }
      };
    },
    // created() {
    //   // Замените на фактический метод получения данных статьи
    //   this.fetchArticle(this.id);
    // },
    // methods: {
    //   fetchArticle(id) {
    //     // Пример запроса на сервер для получения статьи по ID
    //     // Здесь используйте фактический API вызов
    //     fetch(`https://api.example.com/articles/${id}`)
    //         .then(response => response.json())
    //         .then(data => {
    //           this.article = data;
    //         });
    //   }
    // }
  };
</script>

<style scoped>
.article-detail {
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
</style>
